
const defaultState = () => ({
    labWorkOrder: {},
    analysisRequests: [],
});

const mutations = {
    setLabWorkOrderState(state, workOrder) {
        state.labWorkOrder = workOrder;
    },
    resetLabWorkOrderState(state) {
        state.labWorkOrder = {};
    },
    setAnalysisRequest(state, analysisRequests) {
        state.analysisRequests = analysisRequests;
    },
    resetAnalysisRequest(state) {
        state.analysisRequests = [];
    },
};

const actions = {
    async getLabWorkOrder({ commit, dispatch }, workOrderId) {
        try {
            const { data } = await this.$rq.getLabWorkOrder(workOrderId);
            commit('setLabWorkOrderState', data);
        } catch (err) {
            dispatch('resetLabWorkOrder');
        }
    },
    async getLabWorkOrderResults({ commit, dispatch }, params) {
        try {
            const queryParam = typeof params === 'string' ? null : { sampleId: params.sampleId };
            const labWorkOrderId = params.labWorkOrderId ? params.labWorkOrderId : params;
            const { data } = await this.$rq.getLabWorkOrderResults(labWorkOrderId, queryParam);
            commit('setAnalysisRequest', data);
        } catch (err) {
            dispatch('resetAnalysisRequest');
        }
    },
    resetLabWorkOrder({ commit }) {
        commit('resetLabWorkOrderState');
    },
};

const getters = {
    labWorkOrder: state => state.labWorkOrder,
    analysisRequests: state => state.analysisRequests,
};

const state = defaultState();

export default {
    state,
    getters,
    actions,
    mutations,
};
